import script from "./FileTree.vue?vue&type=script&setup=true&lang=js"
export * from "./FileTree.vue?vue&type=script&setup=true&lang=js"

import "./FileTree.vue?vue&type=style&index=0&id=2af6446c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2af6446c"]])

export default __exports__